// @ts-strict-ignore
import type { WorkflowInfo } from '~/dashboard/views/workflows/store/engine/types';
import { invalidSaveToWorkflowTypes } from './constants';

const canSaveToWorkflow = (
  currentWorkflow: WorkflowInfo, comparingWorkflow: WorkflowInfo,
) => {
  if (comparingWorkflow.archived) return false;

  const invalidWorkflowTypes = invalidSaveToWorkflowTypes[currentWorkflow.type];

  // no invalid rules are stated
  if (invalidWorkflowTypes === undefined) return true;

  return !invalidWorkflowTypes.has(comparingWorkflow.type);
};

export function buildSaveToAWorkflowOptions(
  currentWorkflow: WorkflowInfo, allWorkflows: WorkflowInfo[],
) {
  return [...allWorkflows]
    .filter(workflow => canSaveToWorkflow(currentWorkflow, workflow))
    .sort((workflow1, workflow2) => (workflow1.name.localeCompare(workflow2.name)))
    .map(workflow => ({
      label: workflow.name,
      meta: { type: workflow.type },
      value: workflow.application_token,
    }));
}
